import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Thermometer(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { fillRule: "evenodd", d: "M9.025 1.025A3.5 3.5 0 0 1 15 3.5v10.759a5.5 5.5 0 1 1-7 0V3.5a3.5 3.5 0 0 1 1.025-2.475ZM11.5 2A1.5 1.5 0 0 0 10 3.5v11.26a1 1 0 0 1-.444.832 3.5 3.5 0 1 0 3.888 0A1 1 0 0 1 13 14.76V3.5A1.5 1.5 0 0 0 11.5 2Z" }) }));
}
